// src/components/Checkbox.jsx
import "./Checkbox.css";

function Checkbox({ label, checked, onChange, name, disabled = false }) {
  return (
    <label className="checkbox">
      <input 
        type="checkbox" 
        name={name} 
        checked={checked} 
        onChange={onChange}
        disabled={disabled}
      />
      <span>{label}</span>
    </label>
  );
}

export default Checkbox;
